import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  onClick?: () => void;
  onPress?: () => void;
  id?: string;
  testId?: string;
  className?: string;
};

/**
 * SecondaryAction — subtle text button.
 * Uses .rc-action-secondary from monastery.css.
 */
export function SecondaryAction({
  children,
  onClick,
  onPress,
  id,
  testId,
  className = "",
}: Props) {
  const handleClick = () => {
    navigator.vibrate?.(10);
    (onClick ?? onPress)?.();
  };

  return (
    <button
      id={id}
      data-testid={testId}
      className={`rc-action-secondary ${className}`}
      onClick={handleClick}
      type="button"
      aria-label={typeof children === "string" ? children : undefined}
    >
      {children}
    </button>
  );
}
